import { useState } from 'react'
import { Stack, Title, Button, Group, TextInput } from '@mantine/core'
import { IconPlus, IconSearch } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { secretsApi } from '@/api'
import { SecretTable } from '@/components/SecretTable'
import { CreateSecretModal } from '@/components/CreateSecretModal'
import { useDisclosure } from '@mantine/hooks'

export function Secrets() {
  const [search, setSearch] = useState('')
  const [createOpened, { open: openCreate, close: closeCreate }] = useDisclosure(false)

  const { data: secrets = [], isLoading, refetch } = useQuery({
    queryKey: ['secrets'],
    queryFn: async () => {
      const { data } = await secretsApi.list()
      return data
    },
    refetchInterval: 30000, // Refresh every 30 seconds
  })

  const filteredSecrets = secrets.filter((secret) =>
    secret.Spec.Name.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <Stack gap="lg">
      <Group justify="space-between">
        <Title order={2}>Secrets</Title>
        <Button leftSection={<IconPlus size={18} />} onClick={openCreate}>
          Create Secret
        </Button>
      </Group>

      <TextInput
        placeholder="Search secrets..."
        leftSection={<IconSearch size={18} />}
        value={search}
        onChange={(e) => setSearch(e.currentTarget.value)}
      />

      <SecretTable secrets={filteredSecrets} loading={isLoading} refetch={refetch} />

      <CreateSecretModal
        opened={createOpened}
        onClose={closeCreate}
        onSuccess={() => {
          closeCreate()
          refetch()
        }}
      />
    </Stack>
  )
}
